import axios from "axios";
import {
  CLEAR_FAULT_ERROR,
  CLEAR_FAULT_HISTORY,
  ERROR_FAULT,
  LOADING_FAULT,
  SUCCESS_GET_DATA_WITH_PRODUCT_ATTRIBUTES,
} from "../../const/actionTypes";
import {
  FAULT_SERVICE_ASSURANCE_Url,
  GET_DATA_WITH_PRODUCT_ATTRIBUTES_Url,
  GET_NATURE_OF_COMPLAIN_Url,
  GET_CUSTOMER_INDENTITY_Url,
  GET_BILL_FAULTS_Url,
  GET_ACCOUNT_NUMBERS_BY_TOCKEN_Url,
  GET_ProductNameByForm_Url,
  FAULT_SERVICE_RELOCATION_Url,
  FORM_NAME_URL,
  FORM_CATOGERY_URL,
  SUBMIT_FORM_URL,
  GET_CUSTOMER_INDENTITY_ACCOUNT_Url,
} from "../../const/URL";
import {
  IBillComplaintCreateRequest,
  ICreateComplaintResponse,
  IServiceComplaintCreateRequest,
  IServiceRelocationCreateRequest,
} from "../../interfaces/fault";
import { IBillComplainsFormInputs } from "../../pages/myFaults/reportFault/billComplaint/BillComplaint";
import { IServiceComplainsFormInputs } from "../../pages/myFaults/reportFault/serviceComplaint/ServiceComplaint";
import { Product } from "../../pages/serviceRequest/newService/ServiceRequest";
import { IServiceRelocationFormInputs } from "../../pages/serviceRequest/serviceRelocation/ServiceRelocation";
import axiosInstance from "../../services/axiosInstance";
import { getCustomerReferenceNumber } from "../../services/localStorage";
import hasRequestError from "../../util/hasRequestError";

export const addBillComplaint = (
  data: IBillComplainsFormInputs,
  setSuccess: React.Dispatch<React.SetStateAction<string>>
) => {
  const request: IBillComplaintCreateRequest = {
    description: `${data.remark}/(${data.invoiceMonthStart})/(${data.invoiceMonthEnd})`,
    sltAltContactNumber: data.contactMobile,
    serviceId: "",
    srType: "Bill Disputes",
    insArea: data.natureOfBillFault,
    sltEnterpriseCustomerSegment: "Corporate - Data",
    ttSource: "Enterprise Portal",
    sltbillingAccountNumber: data.serviceId,
    customerReferenceNumber: localStorage.getItem("selectedCusRef") || "",
  };

  return (dispatch: any) => {
    dispatchAction(dispatch, LOADING_FAULT);
    axiosInstance
      .post(FAULT_SERVICE_ASSURANCE_Url + "/CreateBillComplaint", request)
      .then((response) => {
        if (hasRequestError(response)) {
          if (response.data.displayMessage) {
            throw new Error(response.data.displayMessage);
          } else {
            throw new Error(response.data.message);
          }
        }
        const data: ICreateComplaintResponse = response.data;
        setSuccess(data.result);
        dispatchAction(dispatch, CLEAR_FAULT_ERROR);
      })
      .catch((error) => {
        dispatchAction(
          dispatch,
          ERROR_FAULT,
          error.message || "Failed to submit bill complaint details"
        );
      });
  };
};

export const getBillFaults = () => {
  return axiosInstance.get(GET_BILL_FAULTS_Url).then((response) => {
    if (hasRequestError(response)) {
      throw new Error(response.data.message);
    }

    return response.data.dataBundle;
  });
};

export const getDataWithProductAttributes = (
  serviceId: string
): Promise<any> => {
  return axiosInstance
    .get(GET_DATA_WITH_PRODUCT_ATTRIBUTES_Url, { params: { serviceId } })
    .then((response) => {
      if (hasRequestError(response)) {
        throw new Error(response.data.message);
      }
      return response.data.result;
    });
};

export const getNatureOfComplaints = (service: string) => {
  return axiosInstance
    .get(`${GET_NATURE_OF_COMPLAIN_Url}/${service}`)
    .then((response) => {
      if (hasRequestError(response)) {
        throw new Error(response.data.message);
      }
      return response.data;
    });
};

export const getProductNameByForm = (product: String) => {
  return axiosInstance
    .post(GET_ProductNameByForm_Url, {
      headers: {
        Authorization: localStorage.getItem("accessToken") || "",
      },
      formName: product,
    })
    .then((response) => {
      if (hasRequestError(response)) {
        throw new Error(response.data.message);
      }
      return response.data.dataBundle;
    });
};

export const getFormDetailsByProduct = async (product: Product) => {
  try {
    const response = await axiosInstance.post(
      FORM_NAME_URL,
      {
        productId: product.id,
        formName: product.name,
      },
      {
        headers: {
          Authorization: localStorage.getItem("accessToken") || "",
        },
      }
    );

    if (response.data.isSuccess) {
      return response.data.dataBundle;
    } else {
      throw new Error(
        response.data.errorMessage || "Failed to fetch form details"
      );
    }
  } catch (err) {
    throw new Error("Failed to load service form");
  }
};

export const submitFormDetails = async (
  formDataPayload: any,
  serviceType: string
) => {
  try {
    const formData = new FormData();

    for (const key in formDataPayload) {
      if (formDataPayload.hasOwnProperty(key)) {
        formData.append(key, formDataPayload[key]);
      }
    }
    formData.append("Subject", serviceType);

    const response = await axios.post(SUBMIT_FORM_URL, formData, {
      headers: {
        Authorization:
          "Bearer " + localStorage.getItem("enterprise_portal_access_Token") ||
          "",
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.data.isSuccess) {
      return response.data;
    } else {
      throw new Error(
        response.data.errorMessage || "Failed to fetch form details"
      );
    }
  } catch (err) {
    throw new Error("Failed to load service form");
  }
};

export const fetchCategories = async () => {
  try {
    const response = await axiosInstance.get(FORM_CATOGERY_URL, {
      headers: {
        Authorization: localStorage.getItem("accessToken") || "",
      },
    });

    if (response.data.isSuccess) {
      return response.data.dataBundle;
    } else {
      throw new Error(
        response.data.errorMessage || "Failed to fetch form details"
      );
    }
  } catch (err) {
    throw new Error("Failed to fetch service categories");
  }
};

export const getAccountNumbersByToken = () => {
  return axiosInstance
    .get(GET_ACCOUNT_NUMBERS_BY_TOCKEN_Url, {
      headers: {
        Authorization: localStorage.getItem("accessToken") || "",
      },
    })
    .then((response) => {
      if (hasRequestError(response)) {
        throw new Error(response.data.message);
      }
      return response.data.dataBundle;
    });
};

export const getCustomerIdentity = (Id: string) => {
  return axiosInstance
    .get(
      `${GET_CUSTOMER_INDENTITY_Url}?anyCustomerId=${Id}&customerReferenceNumber=${getCustomerReferenceNumber()}`
    )
    .then((response) => {
      if (hasRequestError(response)) {
        throw new Error(response.data.displayMessage);
      }
      return response.data.dataBundle;
    });
};

export const getCustomerIdentityAccounts = (Id: string) => {
  return axiosInstance
    .get(
      `${GET_CUSTOMER_INDENTITY_ACCOUNT_Url}?accountNumber=${Id}&customerReferenceNumber=${getCustomerReferenceNumber()}`
    )
    .then((response) => {
      if (hasRequestError(response)) {
        throw new Error(response.data.displayMessage);
      }
      return response.data.dataBundle;
    });
};

export const addServiceFault = (
  data: IServiceComplainsFormInputs,
  setSuccess: React.Dispatch<React.SetStateAction<string>>
) => {
  const request: IServiceComplaintCreateRequest = {
    id: 1,
    ticketType: "Customer Trouble Ticket",
    description: data.remark,
    sltAltContactNumber: data.technicalContact,
    serviceId: data.serviceId,
    ttSource: "Enterprise Portal",
    customerReferenceNumber: localStorage.getItem("selectedCusRef") || "",
    subArea: data.natureOfFault,
  };

  return (dispatch: any) => {
    dispatchAction(dispatch, LOADING_FAULT);
    axiosInstance
      .post(FAULT_SERVICE_ASSURANCE_Url + "/CreateServiceFault", request)
      .then((response) => {
        if (hasRequestError(response)) {
          if (response.data.displayMessage) {
            throw new Error(response.data.displayMessage);
          } else {
            throw new Error(response.data.message);
          }
        }

        const data: ICreateComplaintResponse = response.data;
        setSuccess(data.result);
        dispatchAction(dispatch, CLEAR_FAULT_ERROR);
      })
      .catch((error) => {
        dispatchAction(
          dispatch,
          ERROR_FAULT,
          error.message || "Failed to save fault details"
        );
      });
  };
};

export const addServiceRelocation = (
  data: IServiceRelocationCreateRequest,
  setSuccess: React.Dispatch<React.SetStateAction<string>>
) => {
  return (dispatch: any) => {
    dispatchAction(dispatch, LOADING_FAULT);
    axiosInstance
      .post(FAULT_SERVICE_RELOCATION_Url, data)
      .then((response) => {
        if (hasRequestError(response)) {
          if (response.data.displayMessage) {
            throw new Error(response.data.displayMessage);
          } else {
            throw new Error(response.data.message);
          }
        }

        const data: ICreateComplaintResponse = response.data;
        setSuccess(data.result);
        dispatchAction(dispatch, CLEAR_FAULT_ERROR);
      })
      .catch((error) => {
        dispatchAction(
          dispatch,
          ERROR_FAULT,
          error.message || "Failed to save fault details"
        );
      });
  };
};

export const getTechnicalContactByCctID = (obj: any) => {
  return (dispatch: any) => {
    dispatchAction(dispatch, LOADING_FAULT);
    axiosInstance
      .get(GET_DATA_WITH_PRODUCT_ATTRIBUTES_Url, { params: obj })
      .then((response) => {
        if (response.status === 200 && response.data.isSuccess === true) {
          dispatchAction(
            dispatch,
            SUCCESS_GET_DATA_WITH_PRODUCT_ATTRIBUTES,
            response.data.result
          );
        } else {
          dispatchAction(dispatch, ERROR_FAULT, response.data.message);
        }
      })
      .catch(() => {
        dispatchAction(
          dispatch,
          ERROR_FAULT,
          "Failed to load Technical Contact by cctid"
        );
      });
  };
};

export const clearErrorFaultNature = () => {
  return (dispatch: any) => {
    dispatchAction(dispatch, CLEAR_FAULT_ERROR);
  };
};

export const clearFaultHistoryList = () => (dispatch: any) =>
  dispatchAction(dispatch, CLEAR_FAULT_HISTORY);

const dispatchAction = (dispatch: any, type: string, payload?: any) => {
  dispatch({
    type: type,
    payload: payload,
  });
};
